import { dataMember, required, typedArray } from 'santee-dcts';
import { EQueryAttachment } from '../../../e-queries/models/e-query-attachment';
import { EQueryStatus } from '../../../e-queries/models/e-query-status';
import { EQueryCCQuestion } from './e-query-c-c-question';

export class ActiveEQuery {
    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required()
    public statusName: EQueryStatus;

    @dataMember()
    @required()
    @typedArray(EQueryCCQuestion)
    public questions: EQueryCCQuestion[];

    @dataMember()
    @required()
    @typedArray(EQueryAttachment)
    public attachments: EQueryAttachment[];

    @dataMember()
    @required()
    public canBeReopened: boolean;
}